export function clientFullName(client) {
    return `${client.name} ${client.lastName}${client.motherLastName ? ` ${client.motherLastName}` : ''}`;
}

export function clientAddres(client) {
    return client.address ? client.address.numberInternal ? `${client.address.street} ${client.address.numberExternal} - ${client.address.numberInternal}` : `${client.address.street} ${client.address.numberExternal}` : client.address;
}